import React, { ReactNode } from 'react';
import cc from 'classnames';
import Button, { Themes } from 'ui/Button/Button';

import styles from './TableFiltersWrapper.module.scss';

interface ITableFiltersWrapper {
  children: ReactNode;
  className?: string;
  btnText?: string;
  submitting?: boolean;
}

const TableFiltersWrapper = ({ children, className, btnText = 'Apply Filters', submitting }: ITableFiltersWrapper) => (
  <div className={styles.container}>
    <div className={cc(styles.filtersWrapper, className)}>{children}</div>
    <div className={styles.btnWrapper}>
      <Button type="submit" fullWidth className={styles.btn} theme={Themes.secondary} disabled={submitting}>
        {btnText}
      </Button>
    </div>
  </div>
);

export default TableFiltersWrapper;
